export default {
  envName: 'development',
  baseURL: 'https://elbdev.frontm.ai',
  gRPCURL: 'https://gwdev.frontm.ai',
  botFilesAPI: 'https://gwdev.frontm.ai/devproxy/dev/botfile?path=',
  filesAPI: 'https://3nf11ibj25.execute-api.us-east-1.amazonaws.com/dev',
  websocketURL : 'wss://ewver6me1d.execute-api.us-east-1.amazonaws.com/dev',
  webSocketAPiKey : process.env.REACT_APP_WEBSOCKET_API_KEY,
  wpsGatewayRestApiKey:'https://6sxl0oh685.execute-api.us-east-1.amazonaws.com/dev',
  jwtLoginURL: "https://6sxl0oh685.execute-api.us-east-1.amazonaws.com/dev",
  xApiKeyForJwtLogin : process.env.REACT_APP_X_API_KEY_JWT_LOGIN,
  imgUploadAPI: 'https://gwdev.frontm.ai/devproxy/dev',
  contentURL: 'https://gwdev.frontm.ai/devproxy/botLogos/',
  soundURL: 'https://gwdev.frontm.ai/devproxy/sounds/',
  paymentGatewayKey: process.env.REACT_APP_PAYMENT_GATEWAY_KEY,
  webertcSignalServer: 'gwdev.frontm.ai',
  mapURL: 'https://devproxymaps.frontm.ai/styles/klokantech-basic/style.json',
  sipURI: 'frontmsecureweb@pstn-dev.frontm.ai',
  sipPassword: process.env.REACT_APP_SIP_PASSWORD,
  sipWebsocket: 'wss://pstn-dev.frontm.ai:8089/ws',
  dailyPlatformUrl: 'https://frontm.daily.co/',
  daily_baseUrl: 'https://y7uq3an27c.execute-api.us-east-1.amazonaws.com/item/video',
  xApiKey: process.env.REACT_APP_X_API_KEY,
  userImageBaseUrl: "https://gwdev.frontm.ai/devproxy/dev/file/profile-pics",

  defaultHomePagebaseUrl: "spinnetdev.frontm.ai",
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  dailyXApiKey: process.env.REACT_APP_DAILY_X_API_KEY,
  //Apptypes
  vikandWebAppType: "vikand",
  stationoneAppType: "stationsatcom",
  onshipAppType: "onship",
  seamedexAppType: "seamedix",
  seadanceAppType: "seadance",
  intelsatAppType: "intelsat",
  ledgidAppType: "ledgid",

  //authCode
  onshipDomain: 'onshipEndUser',
};

